import moment from 'moment-timezone'

export function dateTimeIsUpcoming(dateTime: string) {
  const now = moment.now()

  return moment(dateTime).isAfter(now)
}

export function momentFromDateAndTime(dateTime: string, timezone: string) {
  return moment(dateTime).tz(timezone)
}
